import React, { useState } from 'react'

import { Expandable } from '@application/Interfaces/Atoms/Expandable'
import { ArrowIcon } from '@application/Interfaces/Icons'
import { SeoLinksSection } from '@application/Types/FooterTypes'

import {
    DesktopLinks,
    Link,
    LinksWrapper,
    LinkWrapper,
    MobileCollapse,
    OtherResources,
    SectionWrapper,
    Title,
    Wrapper,
    WrapperContent,
} from './FooterLinks.styled'

export const setExpandStateValue = (setExpanded: (expanded: boolean) => void, expanded: boolean) => (): void => {
    setExpanded(expanded)
}

export const FooterLinks = ({ links }: { links: SeoLinksSection[] }): JSX.Element => {
    const grouped: SeoLinksSection[][] = [[]]
    let count = 0
    let max = 0

    links.map((linkSection) => (max = Math.max(max, linkSection.seoLinks.length)))

    links.forEach((linkSection) => {
        if (count + linkSection.seoLinks.length > max && grouped[grouped.length - 1].length) {
            count = linkSection.seoLinks.length
            grouped.push([])
        } else {
            count += linkSection.seoLinks.length
        }

        grouped[grouped.length - 1].push(linkSection)
    })

    const [expanded, setExpanded] = useState<boolean>(false)

    const content = (
        <WrapperContent>
            {grouped.map((group, index) => {
                return (
                    <SectionWrapper key={`group-${index}`}>
                        {group.map((linkSection) => (
                            <LinksWrapper key={linkSection.title}>
                                <Title>{linkSection.title}</Title>
                                {linkSection.seoLinks.map((link) => (
                                    <LinkWrapper key={link.link}>
                                        <Link to={link.link} title={link.title}>
                                            {link.label}
                                        </Link>
                                    </LinkWrapper>
                                ))}
                            </LinksWrapper>
                        ))}
                    </SectionWrapper>
                )
            })}
        </WrapperContent>
    )

    return (
        <Wrapper>
            <MobileCollapse>
                <OtherResources onClick={setExpandStateValue(setExpanded, !expanded)}>
                    Other Resources <ArrowIcon colorCode="g300" width={30} height={17} />
                </OtherResources>
                <Expandable isOpen={expanded}>{content}</Expandable>
            </MobileCollapse>
            <DesktopLinks>{content}</DesktopLinks>
        </Wrapper>
    )
}
